module.exports = __webpack_public_path__ + "img/valve-and-hose.cd9bacbb.png";